module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.76em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("B")]), _vm._v("y closing time, Amy was in the swing of things at the gift shop. She’d made sales, wrapped gifts with shiny foiled papers and voluminous colored ribbons, unpacked the new stock of handcrafted glass ornaments and delivered flowers to New Life Church.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the latter, she’d enjoyed a chat with Pastor Jacobson and allowed herself, with little effort, to be persuaded to help with the charity food basket preparation and delivery.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve always loved doing the Blessing Baskets,” she’d told her mother when she’d returned to the shop.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dana was cleaning up, setting the shop to rights for closing time. With a smile, she said, “It’s a good thing to do and the interaction will put you right back in the heart of Snowglobe’s Christmas celebrations.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s what I was thinking.” Amy took the bottle of Windex from her mother’s hands and spritzed the glass countertop. “Pastor says he’s had more applications for help than ever this year.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Times are difficult for many people. That’s why it’s important to do what we can. Some towns have angel trees. In Snowglobe we have food and gift baskets.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Apparently the church has had a mountain of donations but not enough volunteers signed up to help sort, box and deliver. Pastor seemed thrilled that I wanted to.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Interesting. I know several who’ve mentioned helping. In fact…” Mom’s voice trailed away and she got a strange expression on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her mother reclaimed the Windex bottle and grabbed a paper towel. Without answering, she crossed to the plate glass window and spritzed, rubbing the pane with all her might.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mom.” Amy carefully pushed aside a box of glass ornaments and followed her mother. “What’s the deal? Why are you acting weird?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Outside the gleaming windows, the sidewalk shone dark and damp beneath golden street lamps adorned with red bows. Snowflakes swirled fat and lazy like falling feathers. Cars motored down the streets past other businesses dressed for the holidays. The tiny town of Snowglobe was a Christmas fantasy, a wish come true.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Inside the warm, sweet-smelling gift shop, Dana lowered the Windex bottle and turned slowly to meet her daughter’s gaze. “Did Pastor Jacobson mention who was in charge of the Blessing Basket drive this year?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I thought Pastor was.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, he’s not. Rafe is.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rafe!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Two people passed the shop windows and slowed to admire the display of a snowy lighted village.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Working with Rafe won’t be a problem, will it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Amy swallowed past the protest rising like a volcano. Work with Rafe? In the same room? For hours on end?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No,” she managed. “No problem at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("Returning from a test drive, Rafe parked the snowmobile in the maintenance bay of Westfield Sports Rentals and dismounted. He pulled off his goggles and helmet, hanging them on the back wall with the rows of similar rental equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His younger brother, Jake, exited the office and strode in his direction. Brotherly love swelled in Rafe’s chest. If not for Jake, he would have arrived home another jobless vet. But before he’d left for the marines, while he was still licking his wounds over losing Amy, he and Jake had come up with the idea of opening a sports rental business. With Rafe’s money, thanks to several years of combat pay, Jake had done the hard work of building the business from the ground up. Knowing this business and his little brother were depending on him had given Rafe something to focus on when war had threatened to overwhelm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d told Jake none of this, of course. But he was grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’d she do?” Jake asked, nodding toward the Polaris. In jeans and pullover sweater, he looked like the college man he would be if not for the shop. Good-looking guy, even if Rafe did say so himself. Dark curly hair, blue eyes and a grin that warned the onlooker he was up to something. Mom claimed her sons looked alike but Rafe figured Jake won the handsome dog contest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The carburetor’s still not right,” Rafe answered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll break it down tomorrow. There must be some sludge buildup in one of the jets.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s what I was thinking.” Rafe fell into step with his brother and returned to the office, a cozy room that served as both business center and customer service area. Rock music boomed from the piped-in stereo. “You gotta change that to Christmas music.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jake shrank back in horror. “A steady dose of smarmy muzak about chestnuts and reindeer? Dude! That stuff poisons the soul.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rafe grinned a little at his brother’s over-the-top reaction. “Customers like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jake gripped his throat and made a strangling sound.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Deal with it. Customer service and all that.” Rafe tapped a fist against his brother’s shoulder. “Besides, a dose of real Christmas would be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good")]), _vm._v(" for your soul, not poison.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Brother, you’re scaring me. You’ve turned into an old man.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The comment, meant as a sibling jest, struck a tender spot. Jake didn’t get it. He hadn’t been where Rafe had been. He hadn’t seen and done and heard things that make a man ponder the important things in life. Rafe thanked God for that. And there was the crux. God. Like Rafe had been before joining the military, Jake’s faith didn’t mean much. He was morally a decent man. That was enough.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Or so Rafe had thought.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If there was one fact big brother had learned on the front lines, it was that men die with God on their lips. Some curse Him. Some call on Him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The latter died in peace. Rafe still heard the former in his dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The song changed to hard-driving heavy metal. He’d heard plenty of that in the desert, too.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everyone needed a little Christmas with its promise of hope and peace. Especially him. If that made him an old man…")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He turned down the stereo. “All the rentals back in for the day?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Two still out.” Jake arched a black eyebrow toward the darkening sky. “Shouldn’t be much longer. Wanna help me count the money?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rafe grinned. “Won’t turn that down. You’re making me a rich man.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Both brothers laughed. They were far from rich and, like most new businesses, struggled at times, but they were growing, too. Rafe moved behind the long, low counter that served as a desk. The counter reminded him of Dana Caldwell’s gift shop. And Amy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’ll never guess who I ran into today,” he said as casually as he could.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Amy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked up in surprise. “News travels fast.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s a fact. So, how is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rafe let a beat pass while he thought about how to answer. Amy, in her jaunty knit beret with her warm smile and her voice breathy and excited, had stolen his senses the moment she’d sailed into The Snowglobe Gift Shoppe arm-in-arm with her mother. He’d had a minute to compose himself, to pretend he hadn’t thought about her every day for the past five years, but her effect lingered with him still.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked the same with shaggy blond hair that flew around her face in wisps and honey-brown eyes she considered too small and plain for beauty. She was wrong about that. Amy sparkled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d known she was coming home, had even prepared himself to see her again. At least he’d thought so.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s home to take over The Snowglobe Gift Shoppe,” he said, pleased at how light and normal his voice sounded. “Dana told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How do you feel about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How do I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feel?")]), _vm._v("” Rafe made a rude noise. “You sound like a psychiatrist. How I feel about anything doesn’t mean squat.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, yeah. Tell it to someone who doesn’t know better.” Jake clapped him on the shoulder. “I was there, dude. Remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rafe kept his head down, sorting rental receipts into neat stacks. “Ancient history.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She broke your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I broke hers.” Amy had wanted to get married before he left for the military. He’d wanted to wait. He was still fuzzy on the particulars but at some point, they’d fought until she’d handed him his ring.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Reciprocal stupidity if you ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I didn’t. We made the right decision.” If he’d been killed in combat, Amy would have been a widow. He couldn’t bear the thought of what that would have done to her. Or worse, what if she’d had a baby? A fatherless baby to raise by herself. The break-up was the best gift he could give her before he left.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That was then,” Jake said. “This is now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My brother the philosopher.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So, when are you going to ask her out?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rafe’s heart jerked. Ask her out? “She wasn’t exactly excited to see me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ask her anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll pass.” No use digging up dry bones.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jake slid the cash receipts into a zippered bag for the night deposit at the bank. “You still in love with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not going to let this go, are you?” Rafe made a notation on the paper pad. Later, he’d do the data entry on the computer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Can’t. My big brother spent four years of his life making the world a better place. I want him to be happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rafe grunted. Little brother knew how to get to him. “I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" happy. This business makes me happy. Being home makes me happy.” He cast an eye toward the stereo. “Christmas music would make me happier.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jake snorted but didn’t go away. “Amy’s pretty hot-looking. Nice girl. So…just to be clear on the subject. If I ask her out, you’d be okay with it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Before Rafe could stop the reaction, he was up and out of his chair, scowling at his little brother over the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A slow, knowing smile spread over Jake’s face. “Gotcha.”")])])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d364187","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/1_Ch02.vue
// module id = 72
// module chunks = 0